const DEFAULTS = {
    config: {
        debug: false,
        cookies: {
            essential: false,
            performance: false,
            comfort: false,
            advertising: false
        },
        marketCode: 'ITA',
        lang: 'it',
        source: 'unknown',
        theme: 'default',
        closeBtn: false,
        enableConfirmCta: false,
        enableSelfOnBoardingCta: false,
        onConfirmCtaCallback: null
    },
    input: {
        downPaymentValue: 1000
    }
};

export default DEFAULTS;
